import { ShapeType } from '@/services/shape';
import { getImageObject, getLayerRecolorEnabled, getRefName } from '../utils';
import { isSourceKeyFormat } from '@/utils/number';

export function DataItemLineProgressBarLayerHandler(
  resAst: Ast,
  layerAst: Ast,
  layer: StoreLayerItem,
  colors: StoreThemeColorItem[]
) {
  layer.attrs.resources = {
    bg: getImageObject(resAst, getRefName(layerAst.attrsMap.bg), colors),
    progress: getImageObject(resAst, getRefName(layerAst.attrsMap.ref), colors),
    indicatorImage: getImageObject(
      resAst,
      getRefName(layerAst.attrsMap.indicatorImage),
      colors
    )
  };
  layer.attrs.recolorEnable = getLayerRecolorEnabled(
    resAst,
    getRefName(layerAst.attrsMap.ref)
  );
  layer.attrs = { ...layerAst.attrsMap, ...layer.attrs };
  layer.attrs.progressBarType = 'line';
  layer.type = ShapeType.ProgressBar;

  // 进度条最大最小值
  const {
    valueStart = 0,
    valueRange = 0,
    growDirection = 'left'
  } = layerAst.attrsMap;
  layer.attrs.valueStart = isSourceKeyFormat(valueStart)
    ? valueStart
    : Number(valueStart);
  layer.attrs.valueEnd =
    isSourceKeyFormat(valueStart) || isSourceKeyFormat(valueRange)
      ? valueStart
      : Number(valueStart) + Number(valueRange);
  layer.attrs.growDirection =
    growDirection == 'left'
      ? 'to-right'
      : growDirection == 'right'
      ? 'to-left'
      : growDirection == 'top'
      ? 'to-bottom'
      : growDirection == 'bottom'
      ? 'to-top'
      : 'to-right';
}
